"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Paper = _interopRequireDefault(require("@mui/material/Paper"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _MenuList = _interopRequireDefault(require("@mui/material/MenuList"));
var _styles = _interopRequireDefault(require("../styles"));
var _Popper = _interopRequireDefault(require("@mui/material/Popper"));
var _HeaderBar = require("./HeaderBar");
var _Typography = _interopRequireDefault(require("../Typography"));
var _tokens = require("../styles/tokens");
var colorBackgroundDropdownThemed = _tokens.colorBrandNeutral100;
var colorBackgroundDropdownHoverThemed = _tokens.colorBrandNeutral300;
var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      cursor: 'pointer',
      '& [class*=\'focusVisible\']': {
        backgroundColor: _tokens.colorCtaBlueBase
      },
      '& .utility [class*=\'focusVisible\']': {
        backgroundColor: 'transparent',
        color: _tokens.colorCtaBlueBase
      }
    },
    dropdownLabel: {
      padding: _tokens.spacing50 + " 0"
    },
    dropdownUtilityLabel: {
      paddingLeft: _tokens.spacing40,
      paddingRight: _tokens.spacing40,
      fontSize: theme.typography.body2.fontSize,
      display: 'flex'
    },
    dropdownMenu: {
      width: '12.5rem',
      backgroundColor: _tokens.colorBrandPrimary,
      '&.themed': {
        backgroundColor: colorBackgroundDropdownThemed
      },
      '&.themed .headerbar-dropdown-menu-item': {
        color: _tokens.colorTextNeutral500
      },
      '&.themed :hover': {
        backgroundColor: colorBackgroundDropdownHoverThemed
      },
      '&.themed :focus': {
        backgroundColor: colorBackgroundDropdownHoverThemed
      }
    },
    dropdownMenuUtility: {
      width: '12.5rem',
      fontSize: _tokens.fontSizeDefault,
      paddingTop: 0
    },
    dropdownMenuItem: {
      color: theme.palette.grey[100],
      whiteSpace: 'normal',
      height: 'auto',
      minHeight: 'auto',
      fontSize: _tokens.fontSizeSmall,
      padding: _tokens.spacing30 + " " + _tokens.spacing40,
      overflowWrap: 'anywhere',
      '&:hover': {
        // TODO: We will need logic to figure this out
        // NOTE: This is a placeholder
        backgroundColor: theme.palette.primary.dark
      },
      '&:focus': {
        backgroundColor: theme.palette.action.base
      }
    },
    dropdownMenuItemUtility: {
      color: theme.palette.grey[600],
      whiteSpace: 'normal',
      height: 'auto',
      fontSize: _tokens.fontSizeDefault,
      '&:not(:last-child)': {
        borderBottom: _tokens.borderWidthThin + " solid " + theme.palette.grey[400]
      },
      padding: _tokens.spacing30 + " 0.1rem",
      margin: "0 " + _tokens.spacing40,
      '&:hover, &:focus': {
        backgroundColor: 'transparent',
        color: _tokens.colorCtaBlueBase,
        '& a': {
          color: _tokens.colorCtaBlueBase
        }
      },
      '& a': {
        color: theme.palette.grey[600],
        '&:hover': {
          backgroundColor: 'transparent',
          color: _tokens.colorCtaBlueBase
        }
      }
    },
    labeledContent: {
      display: 'flex',
      alignItems: 'center',
      '& div': {
        paddingLeft: _tokens.spacing30,
        paddingTop: _tokens.spacing30
      }
    },
    menuContainer: {
      padding: 0
    },
    popperOpen: {
      zIndex: theme.zIndex.headerBarDropdown,
      '&.utility ': {
        // correctly positions the utility dropdown without creating a gap between the utility bar item and the dropdown
        borderTop: "0.25rem solid " + theme.palette.secondary.main
      }
    },
    dropdownMenuHeader: {
      borderBottom: _tokens.borderWidthThick + " solid " + theme.palette.grey[400],
      margin: "0 " + _tokens.spacing40,
      padding: _tokens.spacing40 + " 0"
    }
  };
};
var HeaderBarDropdownConsumer = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2.default)(HeaderBarDropdownConsumer, _React$Component);
  function HeaderBarDropdownConsumer() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      open: false
    };
    _this.handleOpen = function (event, context) {
      // prevents HeaderBarDropdown menu from opening if the menu is disabled
      // and prevents the menu from staying open when a menu item is clicked
      if (!_this.props.disabled && event.target.getAttribute('data-id') === 'HeaderBarDropdownLabel') {
        _this.setState({
          open: true
        }, function () {
          setTimeout(function () {
            return context.setOpen(true);
          });
        });
      }
    };
    _this.handleClose = function (event, context, item) {
      // TODO: Use react's equivalent to check node name.
      if (event.type === 'click' && event.target.nodeName === 'LI') {
        var activeLink = document.querySelector('.activeLink');
        if (activeLink) {
          activeLink.classList.remove('activeLink');
        }
      }
      if (item) {
        // look for child anchors, click them if they're there
        var anchor = event.target && event.target.querySelector('a');
        if (anchor) {
          anchor.click();
        } else {
          _this.props.onMenuItemClick(event, item);

          // let our parent know that an item was selected
          if (_this.props.itemSelected) {
            _this.props.itemSelected();
          }
        }
      }
      _this.setState({
        open: false
      });
      setTimeout(function () {
        return context.setOpen(false);
      });
    };
    _this.handleBlur = function (event, context) {
      // if focus leaves a menu header, determine whether it's moved to the associated menu;
      // if it has NOT, close the menu
      if (event.relatedTarget && !event.relatedTarget.classList.contains('headerbar-dropdown-menu-item') || event.relatedTarget === null) {
        _this.handleClose(event, context);
      }
    };
    return _this;
  }
  var _proto = HeaderBarDropdownConsumer.prototype;
  /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      classes = _this$props.classes,
      menuItems = _this$props.menuItems,
      dropdownMenuLabel = _this$props.dropdownMenuLabel,
      secondaryDropdownMenuLabel = _this$props.secondaryDropdownMenuLabel;
    var open = this.state.open;
    var dropdownMenuLabelLocal = dropdownMenuLabel;
    if (secondaryDropdownMenuLabel) {
      dropdownMenuLabelLocal = /*#__PURE__*/_react.default.createElement("div", {
        className: this.props.classes.labeledContent
      }, dropdownMenuLabel, /*#__PURE__*/_react.default.createElement("div", {
        "data-key": "content-label"
      }, secondaryDropdownMenuLabel));
    }
    return /*#__PURE__*/_react.default.createElement(_HeaderBar.HeaderBarContext.Consumer, null, function (context) {
      var _classNames;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes.root,
        ref: function ref(node) {
          _this2.target = node;
        },
        onMouseOver: function onMouseOver(e) {
          return _this2.handleOpen(e, context);
        },
        onFocus: function onFocus(e) {
          return _this2.handleOpen(e, context);
        },
        onMouseLeave: function onMouseLeave(e) {
          return _this2.handleClose(e, context);
        },
        onBlur: function onBlur(e) {
          return _this2.handleBlur(e, context);
        },
        onClick: function onClick(e) {
          return _this2.handleOpen(e, context);
        },
        "aria-expanded": open,
        "aria-haspopup": true
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        ,
        tabIndex: 0,
        "data-id": "HeaderBarDropdownLabel"
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
        className: _this2.props.isUtility ? classes.dropdownUtilityLabel : classes.dropdownLabel //eslint-disable-line jsx-a11y/anchor-is-valid
        ,
        onMouseDown: function onMouseDown(e) {
          return e.stopPropagation();
        },
        onMouseUp: function onMouseUp(e) {
          return e.stopPropagation();
        },
        "data-id": "HeaderBarDropdownLabel"
      }, dropdownMenuLabelLocal)), /*#__PURE__*/_react.default.createElement(_Popper.default, {
        placement: _this2.props.isUtility ? 'bottom-end' : 'bottom',
        open: open,
        anchorEl: _this2.target,
        disablePortal: true,
        keepMounted: true,
        transition: false,
        className: (0, _classnames.default)((_classNames = {}, _classNames[classes.popperOpen] = open, _classNames['utility'] = _this2.props.isUtility, _classNames))
      }, /*#__PURE__*/_react.default.createElement(_Paper.default, {
        sx: {
          borderRadius: 0
        }
      }, _this2.props.menuHeader && /*#__PURE__*/_react.default.createElement("div", {
        className: classes.dropdownMenuHeader
      }, /*#__PURE__*/_react.default.createElement(_Typography.default, null, _this2.props.menuHeader)), /*#__PURE__*/_react.default.createElement(_MenuList.default, {
        role: "menu",
        className: (0, _classnames.default)(_this2.props.isUtility ? classes.dropdownMenuUtility : classes.dropdownMenu, {
          'themed': _this2.props.context.isThemed()
        })
      }, menuItems.filter(function (item) {
        return !item.hidden;
      }).map(function (item, index) {
        return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
          key: item.value,
          "data-first": index === 0,
          tabIndex: index === 0 ? 0 : -1,
          className: (0, _classnames.default)('headerbar-dropdown-menu-item', _this2.props.isUtility ? classes.dropdownMenuItemUtility : classes.dropdownMenuItem, {
            'utility': _this2.props.isUtility
          }),
          role: "menuitem",
          disabled: item.disabled,
          onClick: function onClick(e) {
            return _this2.handleClose(e, context, item);
          },
          onKeyUp: function onKeyUp(e) {
            if (e.key === 'Enter') {
              _this2.handleClose(e, context, item);
            }
          }
        }, item.label);
      })))));
    });
  };
  return HeaderBarDropdownConsumer;
}(_react.default.Component); // see below for prop descriptions
HeaderBarDropdownConsumer.propTypes = {
  classes: _propTypes.default.object.isRequired,
  menuItems: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  dropdownMenuLabel: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  onMenuItemClick: _propTypes.default.func,
  isUtility: _propTypes.default.bool,
  secondaryDropdownMenuLabel: _propTypes.default.string,
  itemSelected: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  menuHeader: _propTypes.default.string,
  context: _propTypes.default.object.isRequired // Provided through wrapper
};
HeaderBarDropdownConsumer.defaultProps = {
  disabled: false,
  isUtility: false
};
var HeaderBarDropdown = function HeaderBarDropdown(props) {
  return /*#__PURE__*/_react.default.createElement(_HeaderBar.HeaderBarContext.Consumer, null, function (context) {
    return /*#__PURE__*/_react.default.createElement(HeaderBarDropdownConsumer, (0, _extends2.default)({}, props, {
      context: context
    }));
  });
};
HeaderBarDropdown.propTypes = {
  /** Useful to extend the style applied to components. */
  classes: _propTypes.default.object,
  /** List of menu items with label and callback. */
  menuItems: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  /** A label (or icon) to be displayed for the dropdown */
  dropdownMenuLabel: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  /**
   * An additional label that augments the main label, and appers alongside it.
   */
  secondaryDropdownMenuLabel: _propTypes.default.string,
  /**
   * A callback when an item from dropdown is clicked.
   * This will send and `event` and selected `item` back to callback.
   */
  onMenuItemClick: _propTypes.default.func,
  /**
   * Whether this should be rendered as a utility menu. For internal use only.
   *
   * @ignore
   */
  isUtility: _propTypes.default.bool,
  /**
   * When provided, this will be called whenever an item is selected.
   *
   * This is used internally, to manage HeaderBar selection state.
   *
   * @ignore
   */
  itemSelected: _propTypes.default.func,
  /** Whether this item is disabled */
  disabled: _propTypes.default.bool,
  /**
   * The header for this dropdwn  (optional)
   */
  menuHeader: _propTypes.default.string
};
HeaderBarDropdown.defaultProps = {
  disabled: false,
  isUtility: false
};
var _default = exports.default = (0, _styles.default)(styles)(HeaderBarDropdown);